import React, { useState, useEffect, useRef } from 'react';
import * as XLSX from "xlsx";
import { useConfig } from '../utils/ConfigContext';
import { createAxiosInstance } from '../utils/AxiosInstance';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { end } from '@popperjs/core';
import { set, sub } from 'date-fns';
// const TableHeader = ({ columns }) => {
//     const subCols = columns.flatMap(col => col.subColumns || [col]);
//     const gridTemplateColumns = subCols.map(col => col.width).join(" ");

//     return (


//         <div className="header-grid-container" style={{ position: 'sticky', top: 70, zIndex: 1, width: "fit-content" }}>

//             <div className="header-grid"
//                 style={{
//                     display: "grid",
//                     gridTemplateColumns,
//                     gridTemplateRows: "50px 50px",
//                     border: "1px solid #ccc",
//                     overflow: "hidden",
//                 }}
//             >
//                 {columns.map((col, index) =>
//                     col.rowSpan === 2 ? (
//                         <div key={index} style={{
//                             gridRow: "1 / span 2",
//                             backgroundColor: col.color,
//                             color: "white",
//                             fontWeight: "bold",
//                             display: "flex",
//                             justifyContent: "center",
//                             alignItems: "center",
//                             border: "1px solid #ccc"
//                         }}
//                             className='header-cell test-header'
//                         >{col.label}</div>
//                     ) : (
//                         <div key={index} style={{
//                             gridColumn: `span ${col.subColumns.length}`,
//                             gridRow: "1",
//                             backgroundColor: col.color,
//                             color: "white",
//                             fontWeight: "bold",
//                             display: "flex",
//                             justifyContent: "center",
//                             alignItems: "center",
//                             border: "1px solid #ccc"
//                         }}
//                             className='header-cell'
//                         >{col.label}</div>
//                     )
//                 )}
//                 {columns.flatMap((col) =>
//                     col.subColumns?.map((sub, i) => (
//                         <div key={i + Math.random(5)} className='header-cell' style={cellStyle(sub)}>{sub.label}</div>
//                     )) || []
//                 )}
//             </div>
//         </div>
//     );
// };

// const cellStyle = (col) => ({
//     backgroundColor: col.color,
//     color: 'white',
//     fontWeight: 'bold',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     border: '1px solid #ccc'
// });
// ✅ TABLE COLUMNS DEFINITION (keep keys aligned with transformed API data)
const MAIN_TABLE_HEADER_TOP = [
    { label: "#", rowSpan: 2 },
    { label: "Center Name", rowSpan: 2 },
    { label: "Date", rowSpan: 2 },
    { label: "Lead", colSpan: 2 },
    { label: "Appts.", rowSpan: 2 },
    { label: "Pkgs. Booked", colSpan: 3 },
    { label: "Pkgs. Completed", colSpan: 3 },
    { label: "Tx. Scheduled", colSpan: 2 },
    { label: "Tx. Completed", colSpan: 2 },
    { label: "Comp. Hrs.", rowSpan: 2 },
    { label: "Machines", colSpan: 2 },
    { label: "CUI %", colSpan: 2 },
];

const MAIN_TABLE_HEADER_SECOND = [
    "Total",
    "Cnvt.",
    "SNB",
    "SDT",
    "SNB+SDT",
    "SNB",
    "SDT",
    "SNB+SDT",
    "SNB",
    "SDT",
    "SNB",
    "SDT",
    "SNB",
    "SDT",
    "SNB",
    "SDT",
];

const flatColumns = [
    { label: "#", key: "#" },
    { label: "Center Name", key: "Center Name" },
    { label: "Date", key: "Date" },
    { label: "Total", key: "total_lead" },
    { label: "Converted", key: "converted_lead" },
    { label: "Appts.", key: "appointments" },
    { label: "SNB", key: "package_booked_snb" },
    { label: "SDT", key: "package_booked_sdt" },
    { label: "SNB+SDT", key: "package_booked_snb_sdt" },
    { label: "SNB", key: "package_completed_snb" },
    { label: "SDT", key: "package_completed_sdt" },
    { label: "SNB+SDT", key: "package_completed_snb_sdt" },
    { label: "SNB", key: "treatment_scheduled_snb" },
    { label: "SDT", key: "treatment_scheduled_sdt" },
    { label: "SNB", key: "treatment_completed_snb" },
    { label: "SDT", key: "treatment_completed_sdt" },
    { label: "Comp. Hrs.", key: "comperession_snb" },
    { label: "SNB", key: "machines_snb" },
    { label: "SDT", key: "machines_sdt" },
    { label: "SNB", key: "cui_snb" },
    { label: "SDT", key: "cui_sdt" },
];

// ✅ Transform one period block from API into the keys used by the table
const transformPeriodToTable = (period = {}) => ({
    total_lead: period.leads_total || 0,
    converted_lead: period.leads_converted || 0,
    appointments: period.appointments || 0,
    package_booked_snb: period.package_booked_snb || 0,
    package_booked_sdt: period.package_booked_sdt || 0,
    package_booked_snb_sdt: period.package_booked_snb_sdt || 0,
    package_completed_snb: period.package_completed_snb || 0,
    package_completed_sdt: period.package_completed_sdt || 0,
    package_completed_snb_sdt: period.package_completed_snb_sdt || 0,
    treatment_scheduled_snb: period.treatment_scheduled_snb || 0,
    treatment_scheduled_sdt: period.treatment_scheduled_sdt || 0,
    treatment_completed_snb: period.treatment_completed_snb || 0,
    treatment_completed_sdt: period.treatment_completed_sdt || 0,
    snb_potential_Treatment: period.snb_potential_Treatment || 0,
    sdt_potential_Treatment: period.sdt_potential_Treatment || 0,
    comperession_snb: period.comperession_snb || 0,
    machines_snb: period.machines_snb || 0,
    machines_sdt: period.machines_sdt || 0,
    cui_snb: period.cui_snb,
    cui_sdt: period.cui_sdt
});


// ✅ UTILITY: Generate row data for rendering
// const generateRowData = (dataRow, columns) => {
//     const result = {};
//     columns.forEach(col => {
//         if (col.key) {
//             result[col.key] = dataRow[col.key];
//         } else if (col.label === "#" || col.label === "Center Name" || col.label === "Date") {
//             result[col.label] = dataRow[col.label];
//         } else if (col.subColumns) {
//             col.subColumns.forEach(subCol => {
//                 result[subCol.key] = dataRow[subCol.key];
//             });
//         }
//     });
//     return result;
// };

// ✅ UTILITY: Generate row data without # and Center Name (for repeated rows)
// const generateRowDataWithoutIdentifiers = (dataRow, columns) => {
//     const result = {};
//     columns.forEach(col => {
//         if (col.label === "#" || col.label === "Center Name") {
//             // Set blank for these columns instead of removing
//             result[col.label] = "";
//             return;
//         }
//         if (col.key) {
//             result[col.key] = dataRow[col.key];
//         } else if (col.label === "Date") {
//             result[col.label] = dataRow[col.label];
//         } else if (col.subColumns) {
//             col.subColumns.forEach(subCol => {
//                 result[subCol.key] = dataRow[subCol.key];
//             });
//         }
//     });
//     return result;
// };

// ✅ UTILITY: Get all column widths
// const getColumnWidths = (columns) => {
//     const widths = [];
//     columns.forEach(col => {
//         if (col.subColumns) {
//             col.subColumns.forEach(subCol => {
//                 widths.push(subCol.width);
//             });
//         } else {
//             widths.push(col.width);
//         }
//     });
//     return widths;
// };

// ✅ UTILITY: Get column widths without # and Center Name
const getColumnWidthsWithoutIdentifiers = (columns) => {
    const widths = [];
    columns.forEach(col => {
        if (col.label === "#" || col.label === "Center Name") {
            // Skip these columns
            return;
        }
        if (col.subColumns) {
            col.subColumns.forEach(subCol => {
                widths.push(subCol.width);
            });
        } else {
            widths.push(col.width);
        }
    });
    return widths;
};

// ✅ TABLE ROW COMPONENT
const TableRow = ({ data, widths, variant = "body" }) => {
    const cellValues = Object.values(data);
    const variantClass = {
        header: "bg-light fw-bold border text-dark",
        state_head: "bg-primary-300 text-primary border border-light",
        city_head: "bg-primary-100 text-primary border border-light",
        body: "bg-white text-dark border",
    }[variant];

    return (
        <div className={`d-flex text-center ${variantClass}`}>
            {cellValues.map((cell, index) => (
                <div key={index} style={{ width: widths[index] || "120px" }} className="p-2 border-end">
                    {cell}
                </div>
            ))}
        </div>
    );
};

const stateOrderMap = {
    "Uttarakhand": 0,
    "West Bengal": 1,
    "Maharashtra": 2,
    "Karnataka": 3,
    "Tamil Nadu": 4,
    "Madhya Pradesh": 5,
    "New Delhi": 6,
};

const CenterDailyReportStaticTable = () => {
    const [openPanels, setOpenPanels] = useState({});
    const [stateReports, setStateReports] = useState([]); // [{ stateName, centers: [...], summary: { last_day, last_month, this_month, last_year } }]
    const [isLoading, setIsLoading] = useState(false);
    const { API_BASE_URL } = useConfig(); // ✅ from context
    const AxiosInstance = createAxiosInstance(API_BASE_URL);
    const [openedStatePanel, setOpenedStatePanel] = useState(false);
    const reportTableRef = useRef(null);
    const currentDate = new Date().toISOString().split("T")[0];

    const [modalData, setModalData] = useState(null);
    const [modalLoading, setModalLoading] = useState(false);
    const [dataCategory, setDataCategory] = useState("");
    const [isFullScreenModal, setIsFullScreenModal] = useState(false);
    const [leadModel, setLeadModel] = useState(false);
    const [appointmentModel, setAppointmentModel] = useState(false);
    const [patientModel, setPatientModel] = useState(false);
    const [patientModalHeader, setPatientModalHeader] = useState("");
    const [pdfDropdownOpen, setPdfDropdownOpen] = useState(false);
    const [stateSelectionModal, setStateSelectionModal] = useState(false);
    const [selectedStatesForPrint, setSelectedStatesForPrint] = useState({});
    const LeadStatusMap = {
        0: "New",
        1: "Scheduled",
        2: "Follow Up",
        3: "Converted",
        4: "Closed",
        5: "Transferred",
    };


    // const widths = getColumnWidths([]);
    // const stickyTop = 72;
    // const stickySecondRowTop = openedStatePanel ? 140 : 114;
    const firstHeaderRowStyle = {
        // position: "sticky",
        // top: stickyTop,
        // zIndex: 20,
        backgroundColor: "#009ed6",
        color: "white",
    };
    const firstHeaderRowSpanStyle = {
        // position: "sticky",
        // top: stickyTop,
        // zIndex: 21,
        backgroundColor: "#009ed6",
        color: "white",
    };
    const secondHeaderRowStyle = {
        // position: "sticky",
        // top: stickySecondRowTop,
        // zIndex: 19,
        backgroundColor: "#009ed6",
        color: "white",
    };

    // ✅ Toggle accordion panel open/close
    const togglePanel = (panelId) => {
        setOpenPanels((prev) => {
            const nextPanels = {
                ...prev,
                [panelId]: !prev[panelId],
            };

            const hasAnyOpenStatePanel = Object.keys(nextPanels).some(
                (key) => key.startsWith("state-") && nextPanels[key]
            );
            setOpenedStatePanel(hasAnyOpenStatePanel);

            return nextPanels;
        });
    };

    const buildEmptyMetrics = () => ({
        total_lead: 0,
        converted_lead: 0,
        appointments: 0,
        package_booked_snb: 0,
        package_booked_sdt: 0,
        package_booked_snb_sdt: 0,
        package_completed_snb: 0,
        package_completed_sdt: 0,
        package_completed_snb_sdt: 0,
        treatment_scheduled_snb: 0,
        treatment_scheduled_sdt: 0,
        treatment_completed_snb: 0,
        treatment_completed_sdt: 0,
        snb_potential_Treatment: 0,
        sdt_potential_Treatment: 0,
        comperession_snb: 0,
        machines_snb: 0,
        machines_sdt: 0,
        cui_snb: 0,
        cui_sdt: 0,
    });

    const fetchStateData = async (centerIds, date) => {
        const response = await AxiosInstance.post('/centers/daily_report', { centerIds, today: date });
        const payload = response?.data?.data;
        if (Array.isArray(payload)) { return payload; }
        if (payload && Array.isArray(payload.data)) { return payload.data; }
        console.warn('Unexpected API response shape:', payload);
        return [];
    };

    const fetchCenters = async () => {
        try {
            setIsLoading(true);
            setStateReports([]);

            const response = await AxiosInstance.get('/centers/1');
            const data = response.data?.data || [];

            // Step 1: Group centers by state
            const stateMap = data.reduce((acc, center) => {
                const state = center.hm_state?.trim();

                // Skip centers without a state and exclude New Delhi (as per requirement)
                if (!state || state === "New Delhi") return acc;

                if (!acc[state]) {
                    acc[state] = [];
                }

                acc[state].push({
                    hm_id: center.hm_id,
                    hm_name: center.hm_name,
                    hm_state: state,
                });

                return acc;
            }, {});
            // Step 2: Sort states using stateOrderMap (state wise, one by one)
            // const orderedStates = Object.keys(stateMap).sort(
            //     (a, b) => (stateOrderMap[a] ?? 999) - (stateOrderMap[b] ?? 999)
            // );

            const orderedStates = Object.fromEntries(
                Object.entries(stateMap).sort(([stateA], [stateB]) => {
                    const orderA = stateOrderMap[stateA] ?? Number.MAX_SAFE_INTEGER;
                    const orderB = stateOrderMap[stateB] ?? Number.MAX_SAFE_INTEGER;
                    return orderA - orderB;
                })
            );



            // Step 3: For each state (sequentially), fetch its daily_report data and append rows
            for (const state of Object.keys(orderedStates)) {
                const centersForState = stateMap[state];
                const centerIds = centersForState.map(c => c.hm_id);
                const stateApiData = await fetchStateData(centerIds, currentDate);

                // Build a lookup from hm_id to center info coming from the initial frontend list
                const centersById = centersForState.reduce((map, c) => {
                    map[c.hm_id] = c;
                    return map;
                }, {});

                // Transform API response into table-friendly structure per center
                // and prefer Center Name from frontend (centersForState) instead of daily_report API
                const centersReports = stateApiData.map((item) => {
                    const baseCenter = centersById[item.hm_id] || {
                        hm_id: item.hm_id,
                        hm_name: item.hm_name || 'N/A',
                        hm_state: item.hm_state || state,
                    };
                    return {
                        ...baseCenter,
                        last_day: transformPeriodToTable(item.last_day || {}),
                        last_week: transformPeriodToTable(item.last_week || {}),
                        last_month: transformPeriodToTable(item.last_month || {}),
                        this_month: transformPeriodToTable(item.this_month || {}),
                        last_year_this_month: transformPeriodToTable(item.last_year_this_month || {}),
                    };
                });



                // Build state-level summary (sum of all centers) for each period
                const buildSummaryForPeriod = (periodKey) => {
                    const summary = buildEmptyMetrics();
                    centersReports.forEach((center) => {
                        const metrics = center[periodKey] || {};
                        Object.keys(summary).forEach((k) => {
                            summary[k] += metrics[k] || 0;
                        });
                    });
                    summary.cui_snb =
                        summary.snb_potential_Treatment > 0
                            ? Number(
                                (
                                    (summary.treatment_completed_snb / summary.snb_potential_Treatment) *
                                    100
                                ).toFixed(1)
                            )
                            : 0;
                    summary.cui_sdt =
                        summary.sdt_potential_Treatment > 0
                            ? Number(
                                (
                                    (summary.treatment_completed_sdt / summary.sdt_potential_Treatment) *
                                    100
                                ).toFixed(1)
                            )
                            : 0;
                    return summary;
                };

                const stateReport = {
                    stateName: state,
                    centers: centersReports,
                    summary: {
                        last_day: buildSummaryForPeriod('last_day'),
                        last_week: buildSummaryForPeriod('last_week'),
                        last_month: buildSummaryForPeriod('last_month'),
                        this_month: buildSummaryForPeriod('this_month'),
                        last_year_this_month: buildSummaryForPeriod('last_year_this_month'),
                    },
                };

                // Append rows in table as each state's data arrives
                setStateReports((prev) => [...prev, stateReport]);
            }
        } catch (error) {
            console.error('Error fetching centers / daily report:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchCenters();
    }, []);

    const periodConfigs = [
        { label: "Last Day", key: "last_day" },
        { label: "Last Week", key: "last_week" },
        { label: "This Month", key: "this_month" },
        { label: "Last Month", key: "last_month" },
        { label: "M.o.M.", key: "last_year_this_month" },
    ];

    const buildExportRows = () => {
        const rows = [];
        const aplphabetLowercase = "abcdefghijklmnopqrstuvwxyz";

        stateReports.forEach((stateReport, stateIdx) => {
            periodConfigs.forEach((period, periodIdx) => {
                const metrics = stateReport.summary?.[period.key] || {};
                rows.push({
                    __nameType: "state",
                    __stateName: stateReport.stateName,
                    "#": periodIdx === 0 ? stateIdx + 1 : "",
                    "Center Name": periodIdx === 0 ? stateReport.stateName : "",
                    "Date": period.label,
                    ...metrics,
                    comperession_snb: secondsToHMS(metrics.comperession_snb ?? 0),
                });
            });

            stateReport.centers.forEach((centerReport, centerIdx) => {
                periodConfigs.forEach((period, periodIdx) => {
                    const metrics = centerReport?.[period.key] || {};
                    rows.push({
                        __nameType: "center",
                        __stateName: stateReport.stateName,
                        "#": periodIdx === 0 ? stateIdx + 1 + "(" + aplphabetLowercase[centerIdx] + ")" : "",
                        "Center Name": periodIdx === 0 ? centerReport.hm_name.replaceAll(/SAAOL /gi, "").replaceAll(stateReport.stateName, "") : "",
                        "Date": period.label,
                        ...metrics,
                        comperession_snb: secondsToHMS(metrics.comperession_snb ?? 0),
                    });
                });
            });

            // Add blank row for state separation
            rows.push({
                __nameType: "blank",
                __stateName: stateReport.stateName,
                "#": "",
                "Center Name": "",
                "Date": "",
            });
        });

        return rows;
    };

    const generateExcel = () => {
        if (!stateReports.length) {
            alert("No data available to export.");
            return;
        }

        const tableElement = reportTableRef.current;
        const sourceThead = tableElement?.querySelector("thead");
        const exportRows = buildExportRows();
        const dataRows = exportRows.map((row) =>
            flatColumns.map((col) => row[col.key] ?? "")
        );

        const fallbackHeaderRow = flatColumns.map((col) => col.label);
        let worksheet;

        if (sourceThead) {
            const topHeaderCells = Array.from(sourceThead.querySelectorAll("tr:first-child th"));
            const secondHeaderCells = Array.from(sourceThead.querySelectorAll("tr:nth-child(2) th"));
            const headerTopRow = [];
            const headerSecondRow = [];
            const merges = [];
            let secondRowIdx = 0;
            let colStart = 0;

            topHeaderCells.forEach((th) => {
                const label = (th.textContent || "").trim();
                const colSpan = Number(th.getAttribute("colspan") || 1);
                const rowSpan = Number(th.getAttribute("rowspan") || 1);

                headerTopRow.push(label);
                for (let i = 1; i < colSpan; i += 1) {
                    headerTopRow.push("");
                }

                if (rowSpan > 1) {
                    for (let i = 0; i < colSpan; i += 1) {
                        headerSecondRow.push("");
                    }
                    merges.push({
                        s: { r: 0, c: colStart },
                        e: { r: rowSpan - 1, c: colStart + colSpan - 1 },
                    });
                } else if (colSpan > 1) {
                    for (let i = 0; i < colSpan; i += 1) {
                        headerSecondRow.push((secondHeaderCells[secondRowIdx]?.textContent || "").trim());
                        secondRowIdx += 1;
                    }
                    merges.push({
                        s: { r: 0, c: colStart },
                        e: { r: 0, c: colStart + colSpan - 1 },
                    });
                } else {
                    headerSecondRow.push((secondHeaderCells[secondRowIdx]?.textContent || "").trim());
                    secondRowIdx += 1;
                }

                colStart += colSpan;
            });

            if (headerTopRow.length === flatColumns.length) {
                worksheet = XLSX.utils.aoa_to_sheet([headerTopRow, headerSecondRow, ...dataRows]);
                worksheet["!merges"] = merges;
            } else {
                worksheet = XLSX.utils.aoa_to_sheet([fallbackHeaderRow, ...dataRows]);
            }
        } else {
            worksheet = XLSX.utils.aoa_to_sheet([fallbackHeaderRow, ...dataRows]);
        }

        const workbook = XLSX.utils.book_new();
        const sheetName = "Center Daily Report";
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

        const today = new Date().toISOString().slice(0, 10);
        XLSX.writeFile(workbook, `center_daily_report_${today}.xlsx`);
    };

    const generatePdf = (filterStates = null, onlyStates = false) => {
        if (!stateReports.length) {
            alert("No data available to export.");
            return;
        }

        const tableElement = reportTableRef.current;
        const sourceThead = tableElement?.querySelector("thead");
        if (!sourceThead) {
            alert("Table not ready for PDF export.");
            return;
        }

        const escapeHtml = (text) => {
            if (text == null) return "";
            return String(text)
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#39;");
        };

        let exportRows = buildExportRows();

        // Filter to only show state rows if onlyStates is true
        if (onlyStates) {
            exportRows = exportRows.filter(row => {
                return row.__nameType === "state" || row.__nameType === "blank";
            });
        }

        // Filter rows by states if specified
        if (filterStates && filterStates.length > 0) {
            exportRows = exportRows.filter(row => {
                // Include rows that belong to selected states
                return filterStates.includes(row.__stateName);
            });
        }

        const headerRows = Array.from(sourceThead.querySelectorAll("tr"))
            .map((tr) => {
                const headerCells = Array.from(tr.querySelectorAll("th"))
                    .map((th) => {
                        const text = escapeHtml(th.textContent?.trim() || "");
                        const rowSpan = th.getAttribute("rowspan");
                        const colSpan = th.getAttribute("colspan");
                        const rowSpanAttr = rowSpan ? ` rowspan="${rowSpan}"` : "";
                        const colSpanAttr = colSpan ? ` colspan="${colSpan}"` : "";
                        return `<th${rowSpanAttr}${colSpanAttr}>${text}</th>`;
                    })
                    .join("");
                return `<tr>${headerCells}</tr>`;
            })
            .join("");
        const tableHeaderHtml = `<thead>${headerRows}</thead>`;

        const tbody = exportRows
            .map((row) => {
                const rowType = row.__nameType;

                // Handle blank separator rows
                if (rowType === "blank") {
                    return `<tr style="background-color: #f8f9fa; height: 10px;"><td colspan="21"></td></tr>`;
                }

                const rowCells = flatColumns
                    .map((col) => {
                        const cellValue = escapeHtml(row[col.key] ?? "");
                        if (col.key === "Center Name" && row[col.key]) {
                            const className =
                                rowType === "state" ? "print-state-name" : "print-center-name";
                            return `<td class="${className}">${cellValue}</td>`;
                        }
                        return `<td>${cellValue}</td>`;
                    })
                    .join("");
                return `<tr>${rowCells}</tr>`;
            })
            .join("");

        const printWindow = window.open("", "_blank");
        if (!printWindow) {
            alert("Please allow pop-ups to export PDF.");
            return;
        }

        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
                <head>
                    <title>Center Daily Report</title>
                    <style>
                        body { font-family: Arial, sans-serif; padding: 16px; }
                        h2 { margin: 0 0 8px 0; }
                        .meta { margin: 0 0 12px 0; color: #444; font-size: 12px; }
                        table { border-collapse: collapse; width: 100%; font-size: 11px; white-space: nowrap; }
                        th, td { border: 1px solid #000; padding: 6px; text-align: center; }
                        th { background: #f4f4f4; }
                        thead { position: static !important; top: auto !important; }
                        td.print-state-name { font-weight: 900; text-align: left; }
                        td.print-center-name { font-weight: 600; text-align: right; }
                        @media print {
                            @page { size: landscape; margin: 10mm; }
                            tr:has(td.print-state-name) { page-break-before: always; }
                        }
                    </style>
                </head>
                <body>
                    <h2>Center Daily Report</h2>
                    <p class="meta">Generated on ${new Date().toLocaleString()}</p>
                    <table>
                        ${tableHeaderHtml}
                        <tbody>${tbody}</tbody>
                    </table>
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();

        setTimeout(() => {
            printWindow.print();
            printWindow.onafterprint = () => printWindow.close();
        }, 250);
    };



    const getDetails = async (row, column, subcolumn, centerIds, today = currentDate) => {
        try {

            if (!row || !column || !centerIds?.length) {
                console.warn("Missing parameters for fetching details", { row, column, centerIds });
                return;
            }

            const validrows = ["last_day", "last_week","last_month", "this_month", "last_year_this_month"];

            //validate timeline
            if (!validrows.includes(row)) {
                console.warn("Invalid timeline for fetching details", { row, column, centerIds });
                return;
            }

            const payload = {
                row,
                column,
                subcolumn,
                centerIds,
                today
            }
            setModalData([]);
            setModalLoading(true);
            setDataCategory(column);


            if (column === "leads") {
                setLeadModel(true);
                const response = await AxiosInstance.post('/centers/daily_report_details', payload);
                const data = response?.data?.data || [];

                const flatLeads = (data ?? []).flatMap(source =>
                    (subcolumn === 'total' ? source.total_leads : source.converted ?? []).map(lead => ({
                        ...lead,
                        source_name: source.source_name
                    }))
                );
                setModalData(flatLeads);
            } else if (column === "appointments") {
                setAppointmentModel(true);
                const response = await AxiosInstance.post('/centers/daily_report_details', payload);
                const data = response?.data?.data || [];
                setModalData(data);
            } else if (column === 'package_booked' || column === 'package_completed' || column === 'treatment_scheduled' || column === 'treatment_completed') {
                setPatientModel(true);
                setPatientModalHeader(column.replaceAll("_", " ").toUpperCase() + " - " + subcolumn.toUpperCase());
                const response = await AxiosInstance.post('/centers/daily_report_details', payload);
                const data = response?.data?.data || [];
                setModalData(data);
            }

        } catch (error) {
            console.error("Error in getDetails parameters", { row, column, subcolumn, centerIds, today }, error);
        } finally {
            setModalLoading(false);
        }

    }
    const toggleFullScreenModal = () => {
        setIsFullScreenModal(prev => !prev);
    };




    const escapeHtml = (text) => {
        if (text == null) return "";
        const div = document.createElement("div");
        div.textContent = text;
        return div.innerHTML;
    };
    const getAge = (dob) => {
        if (!dob) return 0;

        const birthDate = new Date(dob);
        const today = new Date();

        let age = today.getFullYear() - birthDate.getFullYear();

        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }


        return age + ' Years';

    };
    const formatedDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };
    const DetailItem = ({ type, sessions, status, dateLabel, date, last_treatment_date = null,total_done_treatment = null }) => (
        <div
            className="border rounded px-2 py-1 mb-1 bg-white"
        >
            <span className="fw-semibold">{type}-{sessions} ({status})</span><br />
            <span className="text-muted small">{dateLabel}: {date}</span>
            {last_treatment_date && (
                <>
                    <br />
                    <span className="text-muted small">Last Treatment: {last_treatment_date}</span>
                </>
            )}
            {total_done_treatment && (
                <>
                    <br />
                    <span className="text-muted small">Total Treatments: {total_done_treatment}</span>
                </>
            )}
        </div>
    );
    const TYPE_MAP = {
        1: "SDT",
        2: "SNB",
    };

    const PackageStatusMap = {
        0: 'Not Started',
        1: 'Activated',
        2: 'Completed',
        3: "Cancelled",
        4: "Cancelling"
    }

    const TABLE_CONFIG = {
        package: {
            label: "Package Details",
            key: "package_details",
            typeLabel: "Package Type",
            dateLabel: "Booking Date",
            getType: (item) => TYPE_MAP[item.package_type],
            getDate: (item) => formatedDate(item.tppm_date),
            getLastTreatmentDate: (item) => item.last_treatment_date ? formatedDate(item.last_treatment_date) : '',
            getStatus: (item) => PackageStatusMap[item.status],
            getSessions: (item) => item.sessions,
        },
        treatment: {
            label: "Treatment Details",
            key: "treatment_details",
            typeLabel: "Treatment Type",
            dateLabel: "Treatment Date",
            getType: (item) => TYPE_MAP[item.treatment_type || item.package_type],
            getDate: (item) => formatedDate(item.ttm_date || item.slot_date),
            getLastTreatmentDate: (item) => item.last_treatment_date ?? '',
            getStatus: (item) => PackageStatusMap[item.package_status || item.tppm_status],
            getSessions: (item) => item.total_sessions || item.sessions,
            getTotalDoneTreatment: (item) => item.total_treatment_done ?? '',
        },
    };

    const mode =
        dataCategory.startsWith('treatment') ? "treatment" : "package";

    const config = TABLE_CONFIG[mode];

    const [expandedRows, setExpandedRows] = useState({});

    const toggleRow = (pm_id) => {
        setExpandedRows(prev => ({
            ...prev,
            [pm_id]: !prev[pm_id]
        }));
    };
    const secondsToHMS = (totalSeconds) => {
        totalSeconds = Number(totalSeconds);

        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        let result = "";

        if (hours > 0) result += `${hours}h `;
        if (minutes > 0) result += `${minutes}m `;
        if (seconds > 0 || result === "") result += `${seconds}s`;

        return result.trim();

    }

    return (
        <>
            <div className="DailyReportTableTest pb-80">
                <div >
                    {isLoading ? (
                        <div className="text-center py-2">
                            Loading daily report state wise...
                        </div>
                    ) : (
                        <div className="btn-group d-flex justify-content-end position-relative">
                            <OverlayTrigger
                                placement="top"
                                delay={{ show: 250, hide: 400 }}
                                overlay={
                                    <Tooltip id="button-pdf">
                                        Print Pdf
                                    </Tooltip>
                                }
                            >
                                <div className=" cursor-pointer w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center me-2 position-relative"
                                    onClick={() => setPdfDropdownOpen(!pdfDropdownOpen)} >
                                    <i className="ri-file-pdf-2-line"></i>

                                    {pdfDropdownOpen && (
                                        <div style={{
                                            position: 'absolute',
                                            top: '100%',
                                            right: 0,
                                            backgroundColor: 'white',
                                            border: '1px solid #ccc',
                                            borderRadius: '4px',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                            zIndex: 1000,
                                            minWidth: '150px',
                                            marginTop: '5px'
                                        }}>
                                            <div
                                                style={{
                                                    padding: '10px 15px',
                                                    cursor: 'pointer',
                                                    borderBottom: '1px solid #eee',
                                                    fontSize: '12px'
                                                }}
                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                                onClick={() => {
                                                    generatePdf();
                                                    setPdfDropdownOpen(false);
                                                }}
                                            >
                                                Print Full Table
                                            </div>
                                            <div
                                                style={{
                                                    padding: '10px 15px',
                                                    cursor: 'pointer',
                                                    fontSize: '12px'
                                                }}
                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                                onClick={() => {
                                                    setStateSelectionModal(true);
                                                    setPdfDropdownOpen(false);
                                                    // Reset selections
                                                    setSelectedStatesForPrint({});
                                                }}
                                            >
                                                Print Full States 
                                            </div>
                                            <div
                                                style={{
                                                    padding: '10px 15px',
                                                    cursor: 'pointer',
                                                    fontSize: '12px'
                                                }}
                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                                onClick={() => {
                                                    generatePdf(null, true);
                                                    setPdfDropdownOpen(false);
                                                }}
                                            >
                                                Print Only States 
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </OverlayTrigger>
                            <OverlayTrigger
                                placement="top"
                                delay={{ show: 250, hide: 400 }}
                                overlay={
                                    <Tooltip id="button-excel">
                                        Download Excel
                                    </Tooltip>
                                }
                            >


                                <div className=" cursor-pointer w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center me-2"
                                    onClick={generateExcel} >
                                    <i className="ri-file-excel-2-line"></i>

                                </div>

                            </OverlayTrigger>

                        </div>

                    )}
                    <div className='' style={{ minHeight: "400px", maxHeight: "800px", overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
                        <table
                            ref={reportTableRef}
                            className="table table-bordered border-2 table-hover text-center align-middle mb-0"
                            style={{ whiteSpace: "nowrap" }}
                        >

                            {/* ================= HEADER ================= */}
                            <thead className="table-primary text-light text-white text-center align-middle border-3 " style={{ position: "sticky", top: 0, zIndex: 3 }}>

                                {/* FIRST ROW */}
                                <tr>
                                    {MAIN_TABLE_HEADER_TOP.map((header, index) => (
                                        <th
                                            key={`header-top-${index}`}
                                            rowSpan={header.rowSpan}
                                            colSpan={header.colSpan}
                                            style={header.rowSpan ? firstHeaderRowSpanStyle : firstHeaderRowStyle}
                                        >
                                            {header.label}
                                        </th>
                                    ))}
                                </tr>

                                {/* SECOND ROW */}
                                <tr>
                                    {MAIN_TABLE_HEADER_SECOND.map((label, index) => (
                                        <th key={`header-second-${index}`} style={secondHeaderRowStyle}>
                                            {label}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            {/* ================= BODY ================= */}
                            <tbody>
                                {stateReports.length ? (

                                    stateReports.map((stateReport, stateIdx) => (
                                        <React.Fragment key={stateReport.stateName}>
                                            {periodConfigs.map((period, periodIdx) => {
                                                const statePanelId = `state-${stateReport.stateName}`;
                                                const metrics = stateReport.summary?.[period.key] || buildEmptyMetrics();
                                                const center_ids = stateReport.centers.map(c => c.hm_id);
                                                return (
                                                    <tr
                                                        key={`${stateReport.stateName}-${period.key}`}
                                                        className="table-primary fw-bold"
                                                        style={{ cursor: "pointer" }}

                                                    >
                                                        {periodIdx === 0 && <td rowSpan={periodConfigs.length}>{stateIdx + 1}</td>}
                                                        {periodIdx === 0 && <td onClick={() => togglePanel(statePanelId)} rowSpan={periodConfigs.length}>{stateReport.stateName}</td>}
                                                        <td>
                                                            {period.label === "M.o.M." ? (
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={<Tooltip id="tooltip-mom">Month over Month</Tooltip>}
                                                                >
                                                                    <span style={{ cursor: "pointer" }}>
                                                                        {period.label}
                                                                    </span>
                                                                </OverlayTrigger>
                                                            ) : (
                                                                period.label
                                                            )}
                                                        </td>
                                                        <td onClick={() => getDetails(period.key, 'leads', 'total', center_ids)} >{metrics.total_lead ?? 0}</td>
                                                        <td onClick={() => getDetails(period.key, 'leads', 'converted', center_ids)}>{metrics.converted_lead ?? 0}</td>
                                                        <td onClick={() => getDetails(period.key, 'appointments', 'completed', center_ids)}>{metrics.appointments ?? 0}</td>
                                                        <td onClick={() => getDetails(period.key, 'package_booked', 'snb', center_ids)}>{metrics.package_booked_snb ?? 0}</td>
                                                        <td onClick={() => getDetails(period.key, 'package_booked', 'sdt', center_ids)}>{metrics.package_booked_sdt ?? 0}</td>
                                                        <td onClick={() => getDetails(period.key, 'package_booked', 'snb_sdt', center_ids)}>{metrics.package_booked_snb_sdt ?? 0}</td>
                                                        <td onClick={() => getDetails(period.key, 'package_completed', 'snb', center_ids)}>{metrics.package_completed_snb ?? 0}</td>
                                                        <td onClick={() => getDetails(period.key, 'package_completed', 'sdt', center_ids)}>{metrics.package_completed_sdt ?? 0}</td>
                                                        <td onClick={() => getDetails(period.key, 'package_completed', 'snb_sdt', center_ids)}>{metrics.package_completed_snb_sdt ?? 0}</td>
                                                        <td onClick={() => getDetails(period.key, 'treatment_scheduled', 'snb', center_ids)}>{metrics.treatment_scheduled_snb ?? 0}</td>
                                                        <td onClick={() => getDetails(period.key, 'treatment_scheduled', 'sdt', center_ids)}>{metrics.treatment_scheduled_sdt ?? 0}</td>
                                                        <td onClick={() => getDetails(period.key, 'treatment_completed', 'snb', center_ids)}>{metrics.treatment_completed_snb ?? 0}</td>
                                                        <td onClick={() => getDetails(period.key, 'treatment_completed', 'sdt', center_ids)}>{metrics.treatment_completed_sdt ?? 0}</td>
                                                        <td >{secondsToHMS(metrics.comperession_snb ?? 0)}</td>
                                                        <td >{metrics.machines_snb ?? 0}</td>
                                                        <td >{metrics.machines_sdt ?? 0}</td>
                                                        <td >{metrics.cui_snb ?? 0}</td>
                                                        <td >{metrics.cui_sdt ?? 0}</td>
                                                    </tr>
                                                );
                                            })}

                                            {!!openPanels[`state-${stateReport.stateName}`] && stateReport.centers.map((center, centerIdx) => {
                                                const panelId = `center-${stateReport.stateName}-${center.hm_id}`;
                                                const isOpen = !!openPanels[panelId];
                                                const firstPeriod = periodConfigs[0];
                                                const firstMetrics = center?.[firstPeriod.key] || buildEmptyMetrics();
                                                const aplphabetLowercase = "abcdefghijklmnopqrstuvwxyz";

                                                return (
                                                    <React.Fragment key={panelId}>
                                                        <tr
                                                            style={{ cursor: "pointer" }}
                                                            // onClick={() => togglePanel(panelId)}
                                                            className="table-info fw-bold"
                                                        >
                                                            <td>{stateIdx + 1 + "(" + (aplphabetLowercase[centerIdx] ?? "") + ")"}</td>
                                                            <td onClick={() => togglePanel(panelId)}>{center.hm_name.replaceAll(/SAAOL /gi, '').replaceAll(stateReport.stateName, "")}</td>
                                                            <td>{firstPeriod.label}</td>
                                                            <td onClick={() => getDetails(firstPeriod.key, 'leads', 'total', [center.hm_id])} >{firstMetrics.total_lead ?? 0}</td>
                                                            <td onClick={() => getDetails(firstPeriod.key, 'leads', 'converted', [center.hm_id])}>{firstMetrics.converted_lead ?? 0}</td>
                                                            <td onClick={() => getDetails(firstPeriod.key, 'appointments', 'completed', [center.hm_id])}>{firstMetrics.appointments ?? 0}</td>
                                                            <td onClick={() => getDetails(firstPeriod.key, 'package_booked', 'snb', [center.hm_id])}>{firstMetrics.package_booked_snb ?? 0}</td>
                                                            <td onClick={() => getDetails(firstPeriod.key, 'package_booked', 'sdt', [center.hm_id])}>{firstMetrics.package_booked_sdt ?? 0}</td>
                                                            <td onClick={() => getDetails(firstPeriod.key, 'package_booked', 'snb_sdt', [center.hm_id])}>{firstMetrics.package_booked_snb_sdt ?? 0}</td>
                                                            <td onClick={() => getDetails(firstPeriod.key, 'package_completed', 'snb', [center.hm_id])}>{firstMetrics.package_completed_snb ?? 0}</td>
                                                            <td onClick={() => getDetails(firstPeriod.key, 'package_completed', 'sdt', [center.hm_id])}>{firstMetrics.package_completed_sdt ?? 0}</td>
                                                            <td onClick={() => getDetails(firstPeriod.key, 'package_completed', 'snb_sdt', [center.hm_id])}>{firstMetrics.package_completed_snb_sdt ?? 0}</td>
                                                            <td onClick={() => getDetails(firstPeriod.key, 'treatment_scheduled', 'snb', [center.hm_id])}>{firstMetrics.treatment_scheduled_snb ?? 0}</td>
                                                            <td onClick={() => getDetails(firstPeriod.key, 'treatment_scheduled', 'sdt', [center.hm_id])}>{firstMetrics.treatment_scheduled_sdt ?? 0}</td>
                                                            <td onClick={() => getDetails(firstPeriod.key, 'treatment_completed', 'snb', [center.hm_id])}>{firstMetrics.treatment_completed_snb ?? 0}</td>
                                                            <td onClick={() => getDetails(firstPeriod.key, 'treatment_completed', 'sdt', [center.hm_id])}>{firstMetrics.treatment_completed_sdt ?? 0}</td>
                                                            <td >{secondsToHMS(firstMetrics.comperession_snb ?? 0)}</td>
                                                            <td >{firstMetrics.machines_snb ?? 0}</td>
                                                            <td >{firstMetrics.machines_sdt ?? 0}</td>
                                                            <td>{firstMetrics.cui_snb ?? 0}</td>
                                                            <td>{firstMetrics.cui_sdt ?? 0}</td>
                                                        </tr>

                                                        {isOpen &&
                                                            periodConfigs.slice(1).map((period) => {
                                                                const metrics = center?.[period.key] || buildEmptyMetrics();
                                                                return (
                                                                    <tr key={`${panelId}-${period.key}`} style={{ cursor: "pointer" }} >
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td>{period.label === "M.o.M." ? (
                                                                            <OverlayTrigger
                                                                                placement="top"
                                                                                overlay={<Tooltip id="tooltip-mom">Month over Month</Tooltip>}
                                                                            >
                                                                                <span style={{ cursor: "pointer" }}>
                                                                                    {period.label}
                                                                                </span>
                                                                            </OverlayTrigger>
                                                                        ) : (
                                                                            period.label
                                                                        )}</td>
                                                                        <td onClick={() => getDetails(period.key, 'leads', 'total', [center.hm_id])}>{metrics.total_lead ?? 0}</td>
                                                                        <td onClick={() => getDetails(period.key, 'leads', 'converted', [center.hm_id])}>{metrics.converted_lead ?? 0}</td>
                                                                        <td onClick={() => getDetails(period.key, 'appointments', 'completed', [center.hm_id])}>{metrics.appointments ?? 0}</td>
                                                                        <td onClick={() => getDetails(period.key, 'package_booked', 'snb', [center.hm_id])}>{metrics.package_booked_snb ?? 0}</td>
                                                                        <td onClick={() => getDetails(period.key, 'package_booked', 'sdt', [center.hm_id])}>{metrics.package_booked_sdt ?? 0}</td>
                                                                        <td onClick={() => getDetails(period.key, 'package_booked', 'snb_sdt', [center.hm_id])}>{metrics.package_booked_snb_sdt ?? 0}</td>
                                                                        <td onClick={() => getDetails(period.key, 'package_completed', 'snb', [center.hm_id])}>{metrics.package_completed_snb ?? 0}</td>
                                                                        <td onClick={() => getDetails(period.key, 'package_completed', 'sdt', [center.hm_id])}>{metrics.package_completed_sdt ?? 0}</td>
                                                                        <td onClick={() => getDetails(period.key, 'package_completed', 'snb_sdt', [center.hm_id])}>{metrics.package_completed_snb_sdt ?? 0}</td>
                                                                        <td onClick={() => getDetails(period.key, 'treatment_scheduled', 'snb', [center.hm_id])}>{metrics.treatment_scheduled_snb ?? 0}</td>
                                                                        <td onClick={() => getDetails(period.key, 'treatment_scheduled', 'sdt', [center.hm_id])}>{metrics.treatment_scheduled_sdt ?? 0}</td>
                                                                        <td onClick={() => getDetails(period.key, 'treatment_completed', 'snb', [center.hm_id])}>{metrics.treatment_completed_snb ?? 0}</td>
                                                                        <td onClick={() => getDetails(period.key, 'treatment_completed', 'sdt', [center.hm_id])}>{metrics.treatment_completed_sdt ?? 0}</td>
                                                                        <td >{secondsToHMS(metrics.comperession_snb ?? 0)}</td>
                                                                        <td >{metrics.machines_snb ?? 0}</td>
                                                                        <td >{metrics.machines_sdt ?? 0}</td>
                                                                        <td >{metrics.cui_snb ?? 0}</td>
                                                                        <td >{metrics.cui_sdt ?? 0}</td>
                                                                    </tr>

                                                                );
                                                            })}
                                                    </React.Fragment>
                                                );
                                            })}
                                            {/* Blank row for state separation */}
                                            <tr style={{ height: "10px", backgroundColor: "#f8f9fa" }}>
                                                <td colSpan="20"></td>
                                            </tr>
                                        </React.Fragment>

                                    ))

                                ) : (
                                    <tr>
                                        <td colSpan="21" className="text-center">
                                            No Data Available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                    </div>




                </div>
            </div>
            {
                leadModel && (
                    <>
                        {/* Backdrop */}
                        <div className="modal-backdrop fade show w-100 h-100"></div>

                        <div
                            className="modal d-block"
                            tabIndex="-1"
                            style={{ position: "fixed", overflowY: "auto" }}
                        >
                            <div className={`modal-dialog ${isFullScreenModal ? 'modal-fullscreen w-100' : 'modal-xl'} modal-dialog-centered modal-dialog-scrollable`}>
                                <div className="modal-content">

                                    {/* Header */}
                                    <div className="modal-header d-flex justify-content-between align-items-center">
                                        <h5 className="modal-title">Lead Details</h5>
                                        <div className="d-flex align-items-center">
                                            {/* download csv button */}
                                            {/* <div className=" cursor-pointer w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center me-2"
                                            >
                                                <i className="ri-file-pdf-2-line"></i>

                                            </div>
                                            <div className=" cursor-pointer w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center me-2"
                                            >
                                                <i className="ri-file-excel-2-line"></i>

                                            </div> */}

                                            <div className='cursor-pointer w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center'
                                                onClick={toggleFullScreenModal} >
                                                {isFullScreenModal ? <i className="ri-fullscreen-exit-line"></i> : <i className="ri-fullscreen-line"></i>}

                                            </div>

                                            <button
                                                type="button"
                                                className="btn-close"
                                                onClick={() => setLeadModel(false)}
                                            ></button>

                                        </div>

                                    </div>

                                    {/* Body */}
                                    <div className="modal-body">
                                        {/* center wise counting */}


                                        {/* Loader */}
                                        {modalLoading && (
                                            <div className="p-4 text-center">
                                                <div className="spinner-border text-primary"></div>
                                                <p className="mt-2 mb-0 fw-bold">Loading...</p>
                                            </div>
                                        )}

                                        {/* Table */}
                                        {!modalLoading && modalData.length > 0 && (
                                            <table className="table table-bordered">
                                                <thead
                                                    style={{
                                                        position: "sticky",
                                                        top: -18,
                                                        backgroundColor: "white",
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Lead Name</th>
                                                        <th>Phone Number</th>
                                                        <th>Age</th>
                                                        <th>Center Name</th>
                                                        <th>Primary Source</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {modalData.map((lead, index) => (
                                                        <tr key={lead.lead_id}>
                                                            <td>{index + 1}</td>
                                                            <td>{lead.name}</td>
                                                            <td>{lead.phone}</td>
                                                            <td> {lead.dob ? getAge(lead.dob) : '-'} </td>
                                                            <td>{lead.center_name}</td>
                                                            <td>
                                                                {lead.source_name === "Transfer from Other Center"
                                                                    ? `Transferred From ${lead.transferred_from}`
                                                                    : lead.source_name}
                                                            </td>
                                                            <td>
                                                                {LeadStatusMap[lead.status] || "Unknown"}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}

                                        {/* Empty State */}
                                        {!modalLoading && modalData.length === 0 && (
                                            <p className="text-center fw-bold">No leads found</p>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }
            {
                appointmentModel && (
                    <>
                        {/* Backdrop */}
                        <div className="modal-backdrop fade show w-100 h-100"></div>

                        <div
                            className="modal d-block"
                            tabIndex="-1"
                            style={{ position: "fixed", overflowY: "auto" }}
                        >
                            <div className={`modal-dialog ${isFullScreenModal ? 'modal-fullscreen w-100' : 'modal-xl'} modal-dialog-centered modal-dialog-scrollable`}>
                                <div className="modal-content">

                                    {/* Header */}
                                    <div className="modal-header d-flex justify-content-between align-items-center">
                                        <h5 className="modal-title">Appointments Details</h5>
                                        <div className="d-flex align-items-center">
                                            {/* <div className=" cursor-pointer w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center me-2"
                                            >
                                                <i className="ri-file-pdf-2-line"></i>

                                            </div> */}

                                            {/* <div className="cursor-pointer w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center me-2"
                                            >
                                                <i className="ri-file-excel-2-line"></i>

                                            </div> */}

                                            <div className='cursor-pointer w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center'
                                                onClick={toggleFullScreenModal} >
                                                {isFullScreenModal ? <i className="ri-fullscreen-exit-line"></i> : <i className="ri-fullscreen-line"></i>}

                                            </div>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                onClick={() => setAppointmentModel(false)}
                                            ></button>
                                        </div>
                                    </div>

                                    {/* Body */}
                                    <div className="modal-body">


                                        {/* Loader */}
                                        {modalLoading && (
                                            <div className="p-4 text-center">
                                                <div className="spinner-border text-primary"></div>
                                                <p className="mt-2 mb-0 fw-bold">Loading...</p>
                                            </div>
                                        )}

                                        {/* Table */}
                                        {!modalLoading && modalData.length > 0 && (
                                            <table className="table table-bordered">
                                                <thead
                                                    style={{
                                                        position: "sticky",
                                                        top: -18,
                                                        backgroundColor: "white",
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Patient Name</th>
                                                        <th>Patient ID</th>
                                                        <th>Age</th>
                                                        <th>Center Name</th>
                                                        <th>Dr. Name</th>
                                                        <th>Date</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {modalData.map((appointment, index) => (
                                                        <tr key={appointment.pam_id}>
                                                            <td>{index + 1}</td>
                                                            <td>{appointment.pm_name}</td>
                                                            <td>{appointment.patient_unique_id}</td>
                                                            <td>{appointment.pm_dob ? getAge(appointment.pm_dob) : '-'}</td>
                                                            <td>{appointment.hm_name}</td>
                                                            <td>
                                                                {appointment.doctor_name || "N/A"}
                                                            </td>
                                                            <td>
                                                                {appointment.pam_app_date || "Unknown"}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}

                                        {/* Empty State */}
                                        {!modalLoading && modalData.length === 0 && (
                                            <p className="text-center fw-bold">No Appointments found</p>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }
            {
                patientModel && (
                    <>
                        {/* Backdrop */}
                        <div className="modal-backdrop fade show w-100 h-100"></div>

                        <div
                            className="modal d-block"
                            tabIndex="-1"
                            style={{ position: "fixed", overflowY: "auto" }}
                        >
                            <div className={`modal-dialog ${isFullScreenModal ? 'modal-fullscreen w-100' : 'modal-xl'} modal-dialog-centered modal-dialog-scrollable`}>
                                <div className="modal-content">

                                    {/* Header */}
                                    <div className="modal-header d-flex justify-content-between align-items-center">
                                        <h5 className="modal-title">{patientModalHeader}</h5>
                                        <div className="d-flex align-items-center">
                                            {/* <div className=" cursor-pointer w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center me-2"
                                            >
                                                <i className="ri-file-pdf-2-line"></i>

                                            </div>
                                           
                                            <div className="cursor-pointer w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center me-2"
                                            >
                                                <i className="ri-file-excel-2-line"></i>

                                            </div> */}

                                            <div className='cursor-pointer w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center'
                                                onClick={toggleFullScreenModal} >
                                                {isFullScreenModal ? <i className="ri-fullscreen-exit-line"></i> : <i className="ri-fullscreen-line"></i>}

                                            </div>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                onClick={() => setPatientModel(false)}
                                            ></button>
                                        </div>
                                    </div>

                                    {/* Body */}
                                    <div className="modal-body">
                                        {/* Loader */}
                                        {modalLoading && (
                                            <div className="p-4 text-center">
                                                <div className="spinner-border text-primary"></div>
                                                <p className="mt-2 mb-0 fw-bold">Loading...</p>
                                            </div>
                                        )}

                                        {/* Table */}
                                        {!modalLoading && modalData.length > 0 && (
                                            <table className="table table-bordered">
                                                <thead
                                                    style={{
                                                        position: "sticky",
                                                        top: -18,
                                                        backgroundColor: "white",
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Patient Name</th>
                                                        <th>PUID</th>
                                                        <th>Age</th>
                                                        <th>Phone</th>
                                                        <th>Center Name</th>
                                                        <th colSpan={2}>{config.label}</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {modalData.map((patient, index) => {
                                                        const items = patient[config.key] || [];
                                                        const visibleItems = items.slice(0, 2);
                                                        const isExpanded = expandedRows[patient.pm_id];

                                                        return (
                                                            <React.Fragment key={patient.pm_id}>
                                                                {/* MAIN ROW */}
                                                                <tr>
                                                                    <td>{index + 1}</td>
                                                                    <td>{patient.patient_name}</td>
                                                                    <td>{patient.patient_unique_id ?? "N/A"}</td>
                                                                    <td>{patient.pm_dob ? getAge(patient.pm_dob) : '-'}</td>
                                                                    <td>{patient.phone ?? "N/A"}</td>
                                                                    <td>{patient.center_name}</td>

                                                                    <td colSpan={2}>
                                                                        {visibleItems.map((item, i) => (
                                                                            <DetailItem
                                                                                key={i}
                                                                                type={config.getType(item)}
                                                                                sessions={config.getSessions(item)}
                                                                                status={config.getStatus(item)}
                                                                                dateLabel={config.dateLabel}
                                                                                date={config.getDate(item)}
                                                                                last_treatment_date={config.getLastTreatmentDate(item)}
                                                                                total_done_treatment={config.getTotalDoneTreatment(item)}
                                                                            />
                                                                        ))}

                                                                        {items.length > 2 && (
                                                                            <div
                                                                                className="text-primary small fw-semibold cursor-pointer mt-1"
                                                                                onClick={() => toggleRow(patient.pm_id)}
                                                                            >
                                                                                {isExpanded
                                                                                    ? "▲ Hide details"
                                                                                    : `▼ View all (${items.length})`}
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                </tr>

                                                                {/* COLLAPSED ROW */}
                                                                {isExpanded && (
                                                                    <tr className="bg-light">
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td colSpan={2}>
                                                                            <div style={{ maxHeight: 200, overflowY: "auto" }}>
                                                                                {items.map((item, i) => (
                                                                                    <DetailItem
                                                                                        key={i}
                                                                                        type={config.getType(item)}
                                                                                        sessions={config.getSessions(item)}
                                                                                        status={config.getStatus(item)}
                                                                                        dateLabel={config.dateLabel}
                                                                                        date={config.getDate(item)}
                                                                                        last_treatment_date={config.getLastTreatmentDate(item)}
                                                                                        total_done_treatment={config.getTotalDoneTreatment(item)}
                                                                                    />
                                                                                ))}
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </React.Fragment>
                                                        );
                                                    })}

                                                </tbody>
                                            </table>
                                        )}

                                        {/* Empty State */}
                                        {!modalLoading && modalData.length === 0 && (
                                            <p className="text-center fw-bold">No Details found</p>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }

            {/* State Selection Modal for PDF */}
            {stateSelectionModal && (
                <>
                    <div className="modal-backdrop fade show w-100 h-100"></div>
                    <div
                        className="modal d-block"
                        tabIndex="-1"
                        style={{ position: "fixed", overflowY: "auto" }}
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Select States to Print</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setStateSelectionModal(false)}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                                        {stateReports.map((stateReport) => (
                                            <div key={stateReport.stateName} className="form-check mb-3">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id={`state-${stateReport.stateName}`}
                                                    checked={selectedStatesForPrint[stateReport.stateName] || false}
                                                    onChange={(e) => {
                                                        setSelectedStatesForPrint(prev => ({
                                                            ...prev,
                                                            [stateReport.stateName]: e.target.checked
                                                        }));
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor={`state-${stateReport.stateName}`}>
                                                    {stateReport.stateName}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => setStateSelectionModal(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => {
                                            const selectedStates = Object.keys(selectedStatesForPrint).filter(s => selectedStatesForPrint[s]);
                                            if (selectedStates.length === 0) {
                                                alert("Please select at least one state");
                                                return;
                                            }
                                            generatePdf(selectedStates);
                                            setStateSelectionModal(false);
                                        }}
                                    >
                                        Print Selected
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default CenterDailyReportStaticTable;
